export const removeEscapingBackslash = <T>(json: any): T => {
    Object.entries(json).forEach(([key, val]: [string, unknown]) => {
        if ((val as string)?.includes('\\n')) {
            json[key] = json[key].replace('\\n', '\n');
        }
    });

    return json;
};
